import { Box, Image } from "@chakra-ui/react";
import imgContent from "../../../assets/images/content/bg/content-aitest.png";
import tContent from "../../../assets/images/content/bg/content-tablet-aitest.png";
import mContent01 from "../../../assets/images/content/bg/content-mobile-aitest-01.png";
import mContent02 from "../../../assets/images/content/bg/content-mobile-aitest-02.png";
import mContent03 from "../../../assets/images/content/bg/content-mobile-aitest-03.png";
import item01 from "../../../assets/images/content/item/item-mobile-aitest-01.png";
import item02 from "../../../assets/images/content/item/item-mobile-aitest-02.png";
import { useContext } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";


const Aitest = () => {
  const screen = useContext(ScreenContext).style;
  const contents = {
    pc: imgContent,
    mobile: tContent,
    tablet: tContent,
  };

  return (
     <Box w={"100%"} display={"flex"} flexDir={"column"} alignItems={"center"}>
     {screen !== "mobile" ?
         <Image
             src={contents[screen]}
             w={"100%"}
             alt=""
           />
       :
         <>
         <Image
             src={mContent01}
             w={"100%"}
             alt=""
           />
         <Box
           display={"flex"}
           w={"90%"}
           h={"fit-content"}
           justifyContent={"start"}
           overflowX={"scroll"}
           css={{
             '&::-webkit-scrollbar': {
               height: '10px'
             },
             '&::-webkit-scrollbar-thumb': {
               background: '#A4A8AD',
               borderRadius: '10px'
             },
             '&::-webkit-scrollbar-track': {
               background: 'transparent',
               height: '15px'
             }
           }}
         >
           <Image
             src={item01}
             minW={"700px"}
             width={"auto"}
             height={"100%"}
             alt=""
           />
         </Box>
         <Image
              src={mContent02}
              w={"100%"}
              alt=""
            />
         <Box
            display={"flex"}
            w={"90%"}
            h={"fit-content"}
            justifyContent={"start"}
            overflowX={"scroll"}
            css={{
              '&::-webkit-scrollbar': {
                height: '10px'
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#A4A8AD',
                borderRadius: '10px'
              },
              '&::-webkit-scrollbar-track': {
                background: 'transparent',
                height: '15px'
              }
            }}
          >
            <Image
              src={item02}
              minW={"700px"}
              width={"auto"}
              height={"100%"}
              alt=""
            />
          </Box>
          <Image
            src={mContent03}
            w={"100%"}
            alt=""
          />
         </>
     }
    </Box>
  );
};

export default Aitest;